import * as React from 'react';
import styled from 'styled-components';

import { COLORS } from '../styles';

interface HeaderItemProps {
  hideOnLowWidth: boolean;
  inMobileMenu?: boolean;
  useTransparentBackground?: boolean;
}

const IconButton = styled.button<HeaderItemProps>`
  background-color: ${props => (props.useTransparentBackground ? 'transparent' : COLORS.white)};
  border-width: 0;
  cursor: pointer;

  height: 48px;
  width: 48px;
  padding: 8px;

  display: ${props => (props.hideOnLowWidth ? 'none' : 'block')};

  div {
    height: 32px;
    width: 32px;
    border-radius: 4px;

    svg {
      height: 24px;
      width: 24px;
      padding: 4px;
      fill: ${COLORS.neutral_600};

      path {
        fill: ${COLORS.neutral_600};
      }
    }
  }

  &:only-child {
    margin: 0;
  }

  &:disabled {
    color: ${COLORS.neutral_300};
    background-color: transparent;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    div {
      background-color: ${COLORS.primary_20};
    }
    div svg path, div svg {
      fill: ${COLORS.primary_700};
    }
  }

  &:focus:not(:disabled) {
    outline: none;

    div {
      box-shadow: 0px 0px 8px ${COLORS.primary_500}, 0px 4px 12px rgba(46, 127, 161, 0.25);
      outline: none;
    }
    div svg path, div svg {
      fill: ${COLORS.neutral_600};
    }
  }

  &:active:not(:disabled) {
    div {
      background: ${COLORS.primary_100};
      box-shadow: none;
    }
    div svg path, div svg {
      fill: ${COLORS.primary_800};
    }
  }
`;

type Props = {
  action: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  hideOnLowWidth?: boolean;
  isInMobileMenu?: boolean;
  disabled?: boolean;
  useTransparentBackground?: boolean;
};

const UIIconButton: React.FunctionComponent<Props> = ({ action, hideOnLowWidth, isInMobileMenu, children, useTransparentBackground, disabled }): React.ReactElement<Props> => {
  const isPressingEnter = (e: any) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      return true;
    }
    return false;
  };

  return (
    <IconButton
      onClick={(event: React.MouseEvent<HTMLButtonElement>) => action(event)}
      onKeyDown={(e: any) => (isPressingEnter(e) ? action() : null)}
      disabled={disabled}
      hideOnLowWidth={hideOnLowWidth || false}
      inMobileMenu={isInMobileMenu}
      useTransparentBackground={useTransparentBackground}>
      <div>{children}</div>
    </IconButton>
  );
};

export default UIIconButton;
